import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN || '';

if (dsn) {
  Sentry.init({
    dsn,
    tracesSampleRate: 0.1,
  });
  console.info('Sentry initialized');
} else {
  // No-op when not configured
}

export default Sentry;
